import React, { useState } from '../../vendor/react';
import { Bell, Plus } from '../../vendor/lucide-react';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { useSaas } from '../../features/saas/useSaas';

export function AdminNoticesPage() {
  const saas = useSaas();
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [notice, setNotice] = useState('');

  const publish = () => {
    try {
      saas.actions.saveNotice({ title, message, severity: 'info', active: true, audience: 'all' });
      setTitle('');
      setMessage('');
      setNotice('Aviso publicado.');
    } catch (error) {
      setNotice(error instanceof Error ? error.message : 'No se pudo publicar.');
    }
  };

  return <div className="page-stack">
    <section className="phase8-hero"><div><Badge tone="info"><Bell size={13}/> Comunicación</Badge><h2>Avisos de plataforma</h2><p>Publica mantenimiento, cambios importantes o mensajes para planes específicos.</p></div></section>
    {notice && <div className="action-notice">{notice}</div>}
    <section className="admin-notice-layout">
      <article className="panel"><div className="movement-form">
        <label className="field"><span>Título</span><input value={title} onChange={(event)=>setTitle(event.target.value)}/></label>
        <label className="field"><span>Mensaje</span><textarea rows={5} value={message} onChange={(event)=>setMessage(event.target.value)}/></label>
        <Button onClick={publish}><Plus size={16}/> Publicar aviso</Button>
      </div></article>
      <article className="panel"><header className="panel__header"><div><span>Historial</span><h3>Avisos creados</h3></div></header>
        {saas.notices.length ? saas.notices.map((item)=><div className="admin-notice-item" key={item.id}><Badge tone={item.severity==='critical'?'danger':item.severity==='warning'?'warning':'info'}>{item.audience}</Badge><strong>{item.title}</strong><p>{item.message}</p><small>{new Date(item.createdAt).toLocaleString('es-MX')}</small></div>) : <div className="empty-state"><p>No hay avisos publicados.</p></div>}
      </article>
    </section>
  </div>;
}
